module.exports = __webpack_public_path__ + "static/media/yoast.0d953eec.svg";